import { render, staticRenderFns } from "./report-form-column.vue?vue&type=template&id=961e16da&scoped=true"
import script from "./report-form-column.vue?vue&type=script&lang=js"
export * from "./report-form-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e16da",
  null
  
)

export default component.exports